import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class DeNativeDateAdapter extends NativeDateAdapter {
  // Parse manually typed values like "17.9.2025" or "17.09.2025"
  override parse(value: any): Date | null {
    if (typeof value === 'string' && value.trim().length) {
      const trimmed = value.trim();
      const match = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(trimmed);
      if (match) {
        const day = +match[1];
        const month = +match[2] - 1;
        const year = +match[3];
        const date = new Date(year, month, day);
        return isNaN(date.getTime()) ? null : date;
      }
    }
    // fallback to default
    return super.parse(value);
  }

  // Format how the date shows in the input field
  override format(date: Date, displayFormat: Object): string {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }
}
